import { RouterModule, Routes } from '@angular/router';
import { CapabilityRequestComponent } from './capability-request/capability-request.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';

const routes: Routes = [
    { path: 'confirmation/:requestId', component: ConfirmationComponent },
    { path: '**', pathMatch: 'full', component: CapabilityRequestComponent }
];

export const appRoutes = RouterModule.forRoot(routes, {useHash: true});
